import React from "react";

const ReestablecimientoMessages = ({ titulo, telefono, correo }) => {
  return (
    <div>
      <p>{titulo}:</p>
      <p>Número de teléfono: {telefono}</p>
      <p>Correo electrónico: {correo}</p>
    </div>
  );
};

export default ReestablecimientoMessages;
